module.exports = __webpack_public_path__ + "img/xmark.f4a40ce0.svg";